__turbopack_context__.v({
  "accionesEnLinea": "inlineCollection-module__dBPIRG__accionesEnLinea",
  "actionBtn": "inlineCollection-module__dBPIRG__actionBtn",
  "actionDangerBtn": "inlineCollection-module__dBPIRG__actionDangerBtn",
  "actionEditBtn": "inlineCollection-module__dBPIRG__actionEditBtn",
  "actionSaveBtn": "inlineCollection-module__dBPIRG__actionSaveBtn",
  "addInlineRowBtn": "inlineCollection-module__dBPIRG__addInlineRowBtn",
  "addInlineRowIcon": "inlineCollection-module__dBPIRG__addInlineRowIcon",
  "autoSortInfoBadge": "inlineCollection-module__dBPIRG__autoSortInfoBadge",
  "autoSortInfoBadgeNeutral": "inlineCollection-module__dBPIRG__autoSortInfoBadgeNeutral",
  "autoSortInfoBadgeWarning": "inlineCollection-module__dBPIRG__autoSortInfoBadgeWarning",
  "autoSortInfoLabel": "inlineCollection-module__dBPIRG__autoSortInfoLabel",
  "autoSortInfoPopover": "inlineCollection-module__dBPIRG__autoSortInfoPopover",
  "campo": "inlineCollection-module__dBPIRG__campo",
  "campoError": "inlineCollection-module__dBPIRG__campoError",
  "campoErrorVisible": "inlineCollection-module__dBPIRG__campoErrorVisible",
  "changePart": "inlineCollection-module__dBPIRG__changePart",
  "changePartCreated": "inlineCollection-module__dBPIRG__changePartCreated",
  "changePartDeleted": "inlineCollection-module__dBPIRG__changePartDeleted",
  "changePartGroup": "inlineCollection-module__dBPIRG__changePartGroup",
  "changePartOrder": "inlineCollection-module__dBPIRG__changePartOrder",
  "changePartUpdated": "inlineCollection-module__dBPIRG__changePartUpdated",
  "changeSeparator": "inlineCollection-module__dBPIRG__changeSeparator",
  "changeSummary": "inlineCollection-module__dBPIRG__changeSummary",
  "changeSummaryEmpty": "inlineCollection-module__dBPIRG__changeSummaryEmpty",
  "createRowGrow": "inlineCollection-module__dBPIRG__createRowGrow",
  "deleteConfirmTitle": "inlineCollection-module__dBPIRG__deleteConfirmTitle",
  "fechaCampo": "inlineCollection-module__dBPIRG__fechaCampo",
  "fechaErrorFila": "inlineCollection-module__dBPIRG__fechaErrorFila",
  "fechaLabelAside": "inlineCollection-module__dBPIRG__fechaLabelAside",
  "fechaLabelAsideError": "inlineCollection-module__dBPIRG__fechaLabelAsideError",
  "fechaLabelRow": "inlineCollection-module__dBPIRG__fechaLabelRow",
  "fechaMesAnio": "inlineCollection-module__dBPIRG__fechaMesAnio",
  "fechaPrecisionCompacto": "inlineCollection-module__dBPIRG__fechaPrecisionCompacto",
  "fechaPrecisionItem": "inlineCollection-module__dBPIRG__fechaPrecisionItem",
  "fechaPrecisionMenu": "inlineCollection-module__dBPIRG__fechaPrecisionMenu",
  "fechaPrecisionMenuCheck": "inlineCollection-module__dBPIRG__fechaPrecisionMenuCheck",
  "fechaPrecisionMenuItem": "inlineCollection-module__dBPIRG__fechaPrecisionMenuItem",
  "fechaPrecisionMenuItemActive": "inlineCollection-module__dBPIRG__fechaPrecisionMenuItemActive",
  "fechaPrecisionOption": "inlineCollection-module__dBPIRG__fechaPrecisionOption",
  "fechaPrecisionOptionActive": "inlineCollection-module__dBPIRG__fechaPrecisionOptionActive",
  "fechaPrecisionSep": "inlineCollection-module__dBPIRG__fechaPrecisionSep",
  "fechaPrecisionSwitch": "inlineCollection-module__dBPIRG__fechaPrecisionSwitch",
  "fechaPrecisionSwitchVisible": "inlineCollection-module__dBPIRG__fechaPrecisionSwitchVisible",
  "inlineDeleteIndented": "inlineCollection-module__dBPIRG__inlineDeleteIndented",
  "inlineDeleteQuestion": "inlineCollection-module__dBPIRG__inlineDeleteQuestion",
  "inlineEditContent": "inlineCollection-module__dBPIRG__inlineEditContent",
  "inlineEditField": "inlineCollection-module__dBPIRG__inlineEditField",
  "inlineEditFieldIcon": "inlineCollection-module__dBPIRG__inlineEditFieldIcon",
  "inlineEditFieldTitle": "inlineCollection-module__dBPIRG__inlineEditFieldTitle",
  "inlineEditFieldTitleWithIcon": "inlineCollection-module__dBPIRG__inlineEditFieldTitleWithIcon",
  "inlineEditGrid": "inlineCollection-module__dBPIRG__inlineEditGrid",
  "inlineEmptyState": "inlineCollection-module__dBPIRG__inlineEmptyState",
  "inlineEndDateDisabled": "inlineCollection-module__dBPIRG__inlineEndDateDisabled",
  "inlineList": "inlineCollection-module__dBPIRG__inlineList",
  "inlineListActions": "inlineCollection-module__dBPIRG__inlineListActions",
  "inlineListContent": "inlineCollection-module__dBPIRG__inlineListContent",
  "inlineListDescription": "inlineCollection-module__dBPIRG__inlineListDescription",
  "inlineListEnd": "inlineCollection-module__dBPIRG__inlineListEnd",
  "inlineListItem": "inlineCollection-module__dBPIRG__inlineListItem",
  "inlineListItemCreating": "inlineCollection-module__dBPIRG__inlineListItemCreating",
  "inlineListItemDeleting": "inlineCollection-module__dBPIRG__inlineListItemDeleting",
  "inlineListItemEditing": "inlineCollection-module__dBPIRG__inlineListItemEditing",
  "inlineListItemFlash": "inlineCollection-module__dBPIRG__inlineListItemFlash",
  "inlineListItemMuted": "inlineCollection-module__dBPIRG__inlineListItemMuted",
  "inlineListMeta": "inlineCollection-module__dBPIRG__inlineListMeta",
  "inlineListMutedMeta": "inlineCollection-module__dBPIRG__inlineListMutedMeta",
  "inlineListTag": "inlineCollection-module__dBPIRG__inlineListTag",
  "inlineListTitle": "inlineCollection-module__dBPIRG__inlineListTitle",
  "inlineListTitleIcon": "inlineCollection-module__dBPIRG__inlineListTitleIcon",
  "inlineListTitleWithIcon": "inlineCollection-module__dBPIRG__inlineListTitleWithIcon",
  "inlineMetaIcon": "inlineCollection-module__dBPIRG__inlineMetaIcon",
  "inlineMetaLine": "inlineCollection-module__dBPIRG__inlineMetaLine",
  "inlineNewIndicator": "inlineCollection-module__dBPIRG__inlineNewIndicator",
  "inlineNewPulse": "inlineCollection-module__dBPIRG__inlineNewPulse",
  "inlineOngoingLabel": "inlineCollection-module__dBPIRG__inlineOngoingLabel",
  "inputError": "inlineCollection-module__dBPIRG__inputError",
  "labelWrapper": "inlineCollection-module__dBPIRG__labelWrapper",
  "periodoAccionesAparte": "inlineCollection-module__dBPIRG__periodoAccionesAparte",
  "periodoEnCurso": "inlineCollection-module__dBPIRG__periodoEnCurso",
  "periodoFila": "inlineCollection-module__dBPIRG__periodoFila",
  "reorderDeleteIcon": "inlineCollection-module__dBPIRG__reorderDeleteIcon",
  "reorderIndex": "inlineCollection-module__dBPIRG__reorderIndex",
  "reorderMoveBtn": "inlineCollection-module__dBPIRG__reorderMoveBtn",
  "rowApiErrorAbsolute": "inlineCollection-module__dBPIRG__rowApiErrorAbsolute",
  "rowFlash": "inlineCollection-module__dBPIRG__rowFlash",
  "rowPaintSweep": "inlineCollection-module__dBPIRG__rowPaintSweep",
  "rowPositionLabel": "inlineCollection-module__dBPIRG__rowPositionLabel",
  "rowReorderControls": "inlineCollection-module__dBPIRG__rowReorderControls",
  "srOnly": "inlineCollection-module__dBPIRG__srOnly",
  "twoPane": "inlineCollection-module__dBPIRG__twoPane",
  "twoPaneList": "inlineCollection-module__dBPIRG__twoPaneList",
  "twoPaneSide": "inlineCollection-module__dBPIRG__twoPaneSide",
  "valueBump": "inlineCollection-module__dBPIRG__valueBump",
});
